import { render, staticRenderFns } from "./studio_manage.vue?vue&type=template&id=66b5eb38&scoped=true"
import script from "./studio_manage.vue?vue&type=script&lang=ts"
export * from "./studio_manage.vue?vue&type=script&lang=ts"
import style0 from "./studio_manage.vue?vue&type=style&index=0&id=66b5eb38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b5eb38",
  null
  
)

export default component.exports